import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';

export default function DepositionalBreadcrumbWrapperRoute() {
  useBreadcrumb('routes/upload/depositional', 'Geology Wiki');
  return <Outlet />;
}
